<button mat-raised-button *ngIf="type=='raised'"
        style="padding-inline-end: 10px"
        [ngStyle]="{'padding': settings.padding,
                    'padding-inline-start': icon ? '0' : settings.padding,
                    'margin-inline-start': marginBefore,
                    'margin-inline-end': marginAfter,
                    'color': settings.fontColor,
                    'background-color': settings.bgColor}"
        [disabled]="disabled"
        [ngClass]="{'primary': primary}"
        (click)="doAction()"
        [tabindex]="preventFocus?-1:null">
    <div *ngIf="icon" 
         class="layout horizontal center middle">
        <div class="layout horizontal center middle"
             style="height: 40px; width: 40px;">
            <mat-icon [svgIcon]="icon"></mat-icon>
        </div>
        {{label|translate}}
    </div>
    <div *ngIf="!icon" 
         class="layout horizontal center middle">
        {{label|translate}}
    </div>
</button>

<ng-container *ngIf="type=='icon'">
    <button mat-icon-button *ngIf="!(menuOptions && menuOptions.length>0)"
            [ngStyle]="{'margin-inline-start': marginBefore,
                        'margin-inline-end': marginAfter,
                        'color': settings.fontColor}"
                        (click)="doAction()">
            <mat-icon [svgIcon]="icon"></mat-icon>
    </button>
    <button mat-icon-button *ngIf="(menuOptions && menuOptions.length>0)"
            [ngStyle]="{'margin-inline-start': marginBefore,
                        'margin-inline-end': marginAfter,
                        'color': settings.fontColor}"
            [matMenuTriggerFor]="settingsMenu">
            <mat-icon [svgIcon]="icon"></mat-icon>
    </button>
    
    <mat-menu #settingsMenu="matMenu">
    <ng-container *ngFor="let option of menuOptions">
        <button mat-menu-item *ngIf="!option.icon" (click)="doMenuAction(option)">
            {{option.label | translate}}
        </button>
        <button mat-menu-item *ngIf="option.icon" (click)="doMenuAction(option)">
            <mat-icon [svgIcon]="option.icon"></mat-icon>
            <span>{{option.label | translate}}</span>
        </button>
    </ng-container>
    </mat-menu>
</ng-container>